
      <div [class]="tab" *ngIf="tab == 'tabOne'">

          <!--      <form>-->

          <mat-form-field style="padding-right:10px">
             <mat-label class="text-sm">Codice articolo</mat-label>
             <input matInput [(ngModel)]="filtroCodicearticolo" name="filtroCodicearticolo" (keyup)="onFiltroCodicearticoloKeyup($event)" class="text-sm">
          </mat-form-field>

          <mat-form-field style="padding-right:10px">
             <mat-label class="text-sm">Descrizione</mat-label>
             <input matInput [(ngModel)]="filtroDescrizione" name="filtroDescrizione" (keyup)="onFiltroDescrizioneKeyup($event)" class="text-sm">
          </mat-form-field>

          <mat-form-field style="padding-right:10px">
             <mat-label class="text-sm">Giacenza > o = di</mat-label>
             <input matInput #fgte name="filtroGte" (keyup)="onFiltroGteKeyup($event)" class="text-sm">
          </mat-form-field>

          <mat-form-field style="padding-right:10px">
             <mat-label class="text-sm">Giacenza < o = di</mat-label>
             <input matInput #flte name="filtroLte" (keyup)="onFiltroLteKeyup($event)" class="text-sm">
          </mat-form-field>
          <!--
          <mat-checkbox [(ngModel)]="filtroOnlyInStock" name="filtroOnlyInStock" class="text-sm" style="padding-right:10px"
                  (change)="onFiltroOnlyInStockKeyup($event)" >Giacenza positiva
          </mat-checkbox>
          -->
            <!--
                   class="example-margin"
                   [checked]="task().completed"
                   [indeterminate]="partiallyComplete()"
                   (change)="update($event.checked)"
            -->





          <button mat-raised-button  color="primary" (click)="currentPage=1; cerca()">Cerca</button>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

              <ng-container matColumnDef="Id">
                  <th [style.display]="getConfigurazione().Id" mat-header-cell *matHeaderCellDef>Id
                    <img src="./assets/images/sort.png" (click)="manageClick('Id')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Id" mat-cell *matCellDef="let articolo"> {{articolo.Id}} </td>
              </ng-container>

              <ng-container matColumnDef="Catalogo">
                  <th [style.display]="getConfigurazione().Catalogo" mat-header-cell *matHeaderCellDef>Catalogo
                    <img src="./assets/images/sort.png" (click)="manageClick('Catalogo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Catalogo" mat-cell *matCellDef="let articolo"> {{articolo.Catalogo.Nome}} </td>
              </ng-container>

              <ng-container matColumnDef="Codicecatalogo">
                  <th [style.display]="getConfigurazione().Codicecatalogo" mat-header-cell *matHeaderCellDef>Codicecatalogo
                    <img src="./assets/images/sort.png" (click)="manageClick('Codicecatalogo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Codicecatalogo" mat-cell *matCellDef="let articolo"> {{articolo.Codicecatalogo}} </td>
              </ng-container>

              <ng-container matColumnDef="Codicearticolo">
                  <th [style.display]="getConfigurazione().Codicearticolo" mat-header-cell *matHeaderCellDef>Codice articolo
                    <img src="./assets/images/sort.png" (click)="manageClick('Codicearticolo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Codicearticolo" mat-cell *matCellDef="let articolo"> {{articolo.Codicearticolo}} </td>
              </ng-container>

              <ng-container matColumnDef="Descrizione">
                  <th [style.display]="getConfigurazione().Descrizione" mat-header-cell *matHeaderCellDef>Descrizione
                    <img src="./assets/images/sort.png" (click)="manageClick('Descrizione')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Descrizione" mat-cell *matCellDef="let articolo"> {{articolo.Descrizione}} </td>
              </ng-container>

              <ng-container matColumnDef="Categoria">
                  <th [style.display]="getConfigurazione().Categoria" mat-header-cell *matHeaderCellDef>Categoria
                    <img src="./assets/images/sort.png" (click)="manageClick('Categoria')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Categoria" mat-cell *matCellDef="let articolo"> {{articolo.Categoria}} </td>
              </ng-container>
            
              <ng-container matColumnDef="Costo">
                  <th [style.display]="getConfigurazione().Costo" mat-header-cell *matHeaderCellDef>Costo
                    <img src="./assets/images/sort.png" (click)="manageClick('Costo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Costo" mat-cell *matCellDef="let articolo"> {{articolo.Costo | number: '1.2-2' }} </td>
              </ng-container>

              <ng-container matColumnDef="Iva">
                  <th [style.display]="getConfigurazione().Iva" mat-header-cell *matHeaderCellDef>IVA %
                    <img src="./assets/images/sort.png" (click)="manageClick('Iva')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Iva" mat-cell *matCellDef="let articolo"> {{articolo.Iva}} </td>
              </ng-container>

              <ng-container matColumnDef="Prezzo">
                  <th [style.display]="getConfigurazione().Prezzo" mat-header-cell *matHeaderCellDef>Prezzo
                    <img src="./assets/images/sort.png" (click)="manageClick('Prezzo')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Prezzo" mat-cell *matCellDef="let articolo"> {{articolo.Prezzo | number: '1.2-2' }} </td>
              </ng-container>

              <ng-container matColumnDef="Note">
                  <th [style.display]="getConfigurazione().Note" mat-header-cell *matHeaderCellDef>Note
                    <img src="./assets/images/sort.png" (click)="manageClick('Note')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Note" mat-cell *matCellDef="let articolo"> {{articolo.Note}} </td>
              </ng-container>
          
              <ng-container matColumnDef="Giacenza">
                  <th [style.display]="getConfigurazione().Giacenza" mat-header-cell *matHeaderCellDef>Giacenza
                    <img src="./assets/images/sort.png" (click)="manageClick('Giacenza')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Giacenza" mat-cell *matCellDef="let articolo"> {{articolo.Giacenza | number: '1.2-2' }} </td>
              </ng-container>

              <ng-container matColumnDef="Unitamisura">
                  <th [style.display]="getConfigurazione().Unitamisura" mat-header-cell *matHeaderCellDef>Unita di misura
                    <img src="./assets/images/sort.png" (click)="manageClick('Unitamisura')"/>
                  </th>
                  <td [style.display]="getConfigurazione().Unitamisura" mat-cell *matCellDef="let articolo"> {{articolo.Unitamisura}} </td>
              </ng-container>

                <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef> Modifica </th>
                    <td mat-cell *matCellDef="let articolo">
                      <mat-icon color="primary" (click)="edit(articolo)">create</mat-icon>
                    </td>
                </ng-container>
                <ng-container matColumnDef="Quantitarichiesta">
                    <th mat-header-cell *matHeaderCellDef>Quantità richiesta</th>
                    <td mat-cell *matCellDef="let articolo">
                      <ng-container>
                        <input matInput value="{{articolo.Quantitarichiesta}}" (keyup)="onQuantitarichiestaArticoloKeyup(articolo,$event)">
                      </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="shoppingcart">
                    <th mat-header-cell *matHeaderCellDef> Da richiedere </th>
                    <td mat-cell *matCellDef="let articolo">
                       <button [disabled]="isReadonlyArticolorichiesto(articolo)" (click)="saveArticolorichiesto(articolo)">
                         <mat-icon color="primary">add_shopping_cart</mat-icon>
                       </button>
                     </td>
                </ng-container>



                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          <!--
            <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
          -->
          <br>

              <table *ngIf="totalPages>0">
                <tr>
                  <td>
                    <button (click)="goPrevPage()">
                      <mat-icon color="primary">keyboard_arrow_left</mat-icon>
                    </button>
                  </td>
                  <td>
                    <span class="text-sm" style="font-family:Roboto"> {{currentPage}} di {{totalPages}} </span>
                  </td>
                  <td>
                    <button (click)="goNextPage()">
                        <mat-icon color="primary">keyboard_arrow_right</mat-icon>
                    </button>
                  </td>
                </tr>
              </table>
              <table>
                <tr>
                  <td>
                    <button mat-raised-button  color="primary" (click)="new()">Nuovo articolo</button>
                  </td>
                  <td>
                    <button mat-raised-button  color="primary" (click)="cancel(); fgte.value=''; flte.value=''">Cancella</button>
                  </td>
                </tr>
              </table>

            </div>

          <!-- </form> -->

    <div [class]="tab" *ngIf="tab == 'tabTwo'">
      <table mat-table [dataSource]="dataSource2" class="mat-elevation-z8">
 
        <ng-container matColumnDef="Codicearticolo">
            <th mat-header-cell *matHeaderCellDef>Codice articolo</th>
            <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Articolo.Codicearticolo}} </td>
        </ng-container>

        <ng-container matColumnDef="Datarichiesta">
            <th mat-header-cell *matHeaderCellDef>Data richiesta</th>
            <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Datarichiesta | date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Dataordine">
            <th mat-header-cell *matHeaderCellDef>Data ordine</th>
            <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Dataordine | date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Dataconsegna">
            <th mat-header-cell *matHeaderCellDef>Data consegna</th>
            <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Dataconsegna | date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Quantitarichiesta">
          <th mat-header-cell *matHeaderCellDef>Quantità richiesta</th>
  <!--        <td mat-cell *matCellDef="let articolodaordinare">
            <ng-container>
              <input matInput value="{{articolodaordinare.Quantitarichiesta}}" (keyup)="onQuantitarichiestaKeyup(articolodaordinare,$event)">
            </ng-container>--> 
             <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Quantitarichiesta}} </td>
   <!--       </td> -->
        </ng-container>
        <ng-container matColumnDef="Quantitaordinata">
          <th mat-header-cell *matHeaderCellDef>Quantità ordinata</th>
          <td mat-cell *matCellDef="let articolodaordinare">
            <ng-container>
              <input matInput value="{{articolodaordinare.Quantitaordinata}}" (keyup)="onQuantitaordinataKeyup(articolodaordinare,$event)">
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="Quantitaconsegnata">
          <th mat-header-cell *matHeaderCellDef>Quantità consegnata</th>
          <td mat-cell *matCellDef="let articolodaordinare">
   <!--        
            <ng-container>
              <input matInput value="{{articolodaordinare.Quantitaconsegnata}}" (keyup)="onQuantitaconsegnataKeyup(articolodaordinare,$event)">
            </ng-container> --> 
            <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Quantitaconsegnata}} </td> 
        
        </ng-container>
        <ng-container matColumnDef="save">
            <th mat-header-cell *matHeaderCellDef> Salva </th>
            <td mat-cell *matCellDef="let articolodaordinare">
              <button [disabled]="isReadonlyArticolodaordina(articolodaordinare)" (click)="saveArticolodaordinare(articolodaordinare)">
                <mat-icon color="primary">save</mat-icon>
              </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>

      </table>
    </div>
    <div [class]="tab" *ngIf="tab == 'tabThree'">
       <table mat-table [dataSource]="dataSource3" class="mat-elevation-z8">
        <ng-container matColumnDef="Codicearticolo">
          <th mat-header-cell *matHeaderCellDef>Codice articolo</th>
          <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Articolo.Codicearticolo}} </td>
        </ng-container>
        <ng-container matColumnDef="Datarichiesta">
            <th mat-header-cell *matHeaderCellDef>Data richiesta</th>
            <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Datarichiesta | date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Dataordine">
            <th mat-header-cell *matHeaderCellDef>Data ordine</th>
            <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Dataordine | date:'dd/MM/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Dataconsegna">
            <th mat-header-cell *matHeaderCellDef>Data consegna</th>
            <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Dataconsegna | date:'dd/MM/yyyy'}} </td>
        </ng-container>
         <ng-container matColumnDef="Quantitarichiesta">
          <th mat-header-cell *matHeaderCellDef>Quantità richiesta</th>
             <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Quantitarichiesta}} </td>
        </ng-container>
        <ng-container matColumnDef="Quantitaordinata">
          <th mat-header-cell *matHeaderCellDef>Quantità ordinata</th>
          <td  mat-cell *matCellDef="let articolodaordinare"> {{articolodaordinare.Quantitaordinata}} </td>
        </ng-container>
        <ng-container matColumnDef="Quantitaconsegnata">
          <th mat-header-cell *matHeaderCellDef>Quantità consegnata</th>
          <td mat-cell *matCellDef="let articolodaordinare">
            <ng-container>
              <input matInput value="{{articolodaordinare.Quantitaconsegnata}}" (keyup)="onQuantitaconsegnataKeyup(articolodaordinare,$event)">
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="save">
            <th mat-header-cell *matHeaderCellDef> Salva </th>
            <td mat-cell *matCellDef="let articolodaordinare">
              <button [disabled]="isReadonlyArticoloconsegnato(articolodaordinare)" (click)="saveArticoloconsegnato(articolodaordinare)">
                <mat-icon color="primary">save</mat-icon>
              </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>

      </table>
    </div>
